import * as React from 'react';
import ClearCart from "../../../component/Global/Cart/ClearCart"
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import SystemAlerts from "../../../component/SystemAlerts";
import QuoteCartList from './QuoteCartList';
import { useCartStore } from 'src/hooks/cart';
import AlertContentWithFlag from 'src/pages/Checkout/AlertContentWithFlag';
import CartShippingAddress from 'src/pages/Cart/CartLeftContent/CartShippingAddress';
import Notification from 'src/pages/Cart/CartLeftContent/Notification';

const QuoteCartLeftContent = (props) => {
    const [{ }, { }, { SET_SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE }] = useCartStore();
    const [__check] = useAxiosIndicatorCheck();
    const [productAvailableError, setProductAvailableError] = React.useState(false);

    const onChangeCallBack = (countryCode) => {
        SET_SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE(countryCode);
    }

    return (
        <>
            <div className="col-xl-9">
                <div className="col-12 m1-3">
                    <div>
                        <SystemAlerts />
                        {productAvailableError &&
                            <AlertContentWithFlag message={'<span>The part(s) in your cart cannot be shipped to your current <b>shipping country</b>. Please remove them to proceed to Checkout.</span>'} type="danger" isDisplay={false} isDisplayIcon={true} />
                        }
                    </div>
                </div>

                <CartShippingAddress onChangeCallBack={onChangeCallBack} />

                <div className={'pt-1 pb-1'}>
                    <Notification setProductAvailableError={setProductAvailableError} />
                </div>
                <div className={'pt-2 pb-2'}>
                    <ClearCart />
                </div>
                <QuoteCartList /> 
            </div>
        </>
    );
}

export default QuoteCartLeftContent;